module.exports = __webpack_public_path__ + "static/img/rank_295.30a83c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_295.png
// module id = KwqC
// module chunks = 0